/* eslint-disable
    no-unused-vars
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
import React from 'react';
import _ from 'underscore';

import ProtocolDAO from 'notebook/protocols/dao/ProtocolDAO';
import * as ModalContainer from 'ui-library/ModalContainer';

import BaseCreateModal from './BaseCreateModal';
import FolderDefaults, {FolderDefaultsKey} from '../FolderDefaults';

const CREATE_PROTOCOL_MODAL_KEY = 'CreateProtocolModal';

class CreateProtocolModal extends React.Component {
  static close() {
    ModalContainer.close(CREATE_PROTOCOL_MODAL_KEY);
  }

  static open(modal, props) {
    if (props == null) {
      props = {};
    }
    // eslint-disable-next-line no-restricted-syntax
    props = _.extend({}, props, {
      onRequestClose() {
        return ModalContainer.close(CREATE_PROTOCOL_MODAL_KEY);
      },
    });
    ModalContainer.open(CREATE_PROTOCOL_MODAL_KEY, React.createElement(modal, props));
  }

  createProtocol = (name, folderId) => ProtocolDAO.create({name, folder: folderId}).then((resp) => resp.id);

  render() {
    return (
      <BaseCreateModal
        // eslint-disable-next-line no-restricted-syntax
        {..._.extend({}, this.props, {
          title: 'Create protocol',
          create: this.createProtocol,
          showNotebook: true,
          folderDefaultsKey: FolderDefaultsKey.NOTEBOOK,
        })}
        dataTestAttrs={{component: 'CreateProtocolModal', element: 'modal'}}
      />
    );
  }
}

export default CreateProtocolModal;
